import dynamic from "next/dynamic";

export const AnimateIn = dynamic(() => import("./component"));
